import React, { FC } from 'react';
import { createUseStyles } from '../../../../theming';
import { CircularProgress } from '@material-ui/core';
import { Order } from '../../../../interfaces/Table';
import { LegacyCustomer } from 'src/interfaces/api/Customer';
import CustomersMap from './components/CustomersMap';
import Hidden from '../../../components/Hidden';
import CustomersListCard from './components/CustomersListCard';
import SearchBar from './components/SearchBar';
import FiltersButton from './components/FiltersButton';
import { CustomersFilter } from './components/FiltersButton/components/FiltersDialog';
import useWindowDimensions from '../../../../hooks/useWindowDimensions';

const useStyles = createUseStyles({
  root: {
    position: 'relative',
  },
  container: {
    position: 'absolute',
    top: 20,
    right: 20,
    bottom: 20,
    maxWidth: 500,
    zIndex: 10,
    display: 'flex',
    flexDirection: 'column',
    '& > *': {
      marginBottom: 10,
    },
  },
  searchBar: {
    flex: 1,
    marginLeft: 10,
  },
  filters: {},
  customerList: {},
  mapContainer: {
    zIndex: 5,
  },
  loadingContainer: {
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    zIndex: 6,
    backgroundColor: '#00000024',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  filterContainer: {
    display: 'flex',
  },
});

interface Props {
  onRequestSort: (event: React.MouseEvent<unknown>, property: keyof LegacyCustomer) => void;
  customers: LegacyCustomer[];
  loading?: boolean;
  onQueryChange: (newValue: string) => void;
  orderBy: keyof LegacyCustomer;
  order: Order;
  filters: Partial<Record<CustomersFilter, any>>;
  onFilterChange: (filters: Partial<Record<CustomersFilter, any>>) => void;
}

const List: FC<Props> = ({
  customers,
  filters,
  loading,
  onFilterChange,
  onRequestSort,
  onQueryChange,
  order,
  orderBy,
}) => {
  const classes = useStyles();
  const { height } = useWindowDimensions();

  return (
    <div className={classes.root}>
      <CustomersMap className={classes.mapContainer} height={height} customers={customers} />

      {loading && (
        <div className={classes.loadingContainer}>
          <CircularProgress size={30} />
        </div>
      )}

      <div className={classes.container}>
        <div className={classes.filterContainer}>
          <FiltersButton filters={filters} onFilterChange={onFilterChange} />
          <SearchBar onQueryChange={onQueryChange} className={classes.searchBar} />
        </div>

        <Hidden lgDown>
          <CustomersListCard
            className={classes.customerList}
            maxHeight={height}
            customers={customers}
            onRequestSort={onRequestSort}
            order={order}
            orderBy={orderBy}
          />
        </Hidden>
      </div>
    </div>
  );
};

export default List;
